(function($) {
  
  $(document).ready(function() {
    
  });
  
})(jQuery);

function initFooterNewsletter(){
  var $ = jQuery;
  $('.m-footer-newsletter form').on('submit',function(){
    if(!validateEmail($(this).find('input[name="EMAIL"]').val())){
        $('.m-footer-newsletter').addClass('is-form-error');
        return false;
    }else{
        $('.m-footer-newsletter').removeClass('is-form-error');
    }
})
}